export default __webpack_public_path__ + "media/Objective/Objective-Light-349e438031267f5527a9b1cfea0e6c4e.woff2";